import { NgModule } from '@angular/core';
import { SelectAllComponent } from './components/select-all/select-all.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppUiModule } from '../../../../ui/app-ui.module';
import { ChecklistTicketMediaComponent } from './components/checklist-ticket-media/checklist-ticket-media.component';
import { ChecklistTicketAnswersComponent } from './components/checklist-ticket-answers/checklist-ticket-answers.component';
import { ChecklistTicketPdfComponent } from './components/checklist-ticket-pdf/checklist-ticket-pdf.component';

@NgModule({
  imports: [CommonModule, AppUiModule, ReactiveFormsModule],
  declarations: [SelectAllComponent, ChecklistTicketMediaComponent, ChecklistTicketAnswersComponent, ChecklistTicketPdfComponent],
  exports: [SelectAllComponent, ChecklistTicketMediaComponent, ChecklistTicketAnswersComponent, ChecklistTicketPdfComponent],
})
export class CheckListsSharedModule {}
